import { IntRange } from "lavva.exalushome/build/js/Helpers";

export type LightTransitionTime = IntRange<1, 31>;
export type MinLightLevel = IntRange<1, 99>;
export type MaxLightLevel = IntRange<2, 100>;

export class InputOutputDimmerParameters {  
    Channel: number = 0;
    InputModeDimmer: InputModeDimmer = InputModeDimmer.Monostable;
}

export enum InputModeDimmer {
    Monostable = 0,
    Time = 1,
    Bistable = 2,
}